var EventEmitter = /*#__PURE__*/function () {
  function EventEmitter() {
    this._eventListeners = {};
  } // Empty
  var _proto = EventEmitter.prototype;
  _proto.addListener = function addListener(eventName,
  // Using inline Listener here since E is not allowed in an input position
  listener) {
    var existing = this._eventListeners[eventName];
    if (existing) {
      existing.push(listener);
    } else {
      this._eventListeners[eventName] = [listener];
    }
  };
  _proto.removeListener = function removeListener(eventName, listener) {
    var existing = this._eventListeners[eventName];
    if (existing) {
      var i = existing.indexOf(listener);
      if (i >= 0) {
        if (existing.length > 1) {
          existing.splice(i, 1);
        } else {
          delete this._eventListeners[eventName];
        }
      }
    }
  };
  _proto.removeAllListeners = function removeAllListeners(eventName) {
    if (eventName) {
      delete this._eventListeners[eventName];
    } else {
      this._eventListeners = {};
    }
  };
  _proto.listeners = function listeners(eventName) {
    return this._eventListeners[eventName] || [];
  };
  _proto.emit = function emit(eventName) {
    var handler = this._eventListeners[eventName];
    if (handler) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      for (var _i2 = 0; _i2 < handler.length; _i2++) {
        var i = handler[_i2];
        i.apply(void 0, args);
      }
    }
  };
  return EventEmitter;
}();

export { EventEmitter };
//# sourceMappingURL=eventemitter.js.map
